module.exports = __webpack_public_path__ + "img/img10.2444f5a6.jpg";